import { TZDate } from "@date-fns/tz";

import { parseDate } from "@/utils/date";
import { WeekDays } from "@/utils/enums";

export const WEEKDAYS = [
    WeekDays.MONDAY,
    WeekDays.TUESDAY,
    WeekDays.WEDNESDAY,
    WeekDays.THURSDAY,
    WeekDays.FRIDAY,
    WeekDays.SATURDAY,
    WeekDays.SUNDAY
];

export const DATE_FORMAT = "yyyy-MM-dd";
export const TIMEZONE = "Europe/Brussels";

////////////////////////////////////////////////////////////////////////////////////////////////
/// NOTE: These calculations are timezone sensitive (TZDate). Those in @/utils/date are not.  ///
/// Mixing the two can lead to unexpected results, so be careful when using these functions. ///
/// https://redmine.hubo.be/issues/64528 - update date-fns to be able to work with timezones.///
////////////////////////////////////////////////////////////////////////////////////////////////

export const timeToNumber = (time?: string | null) =>
    time ? Number(time.replace(":", "")) : undefined;

export const numberToTime = (time: number) => {
    const timeString = String(time);
    const hours = timeString.slice(0, -2).padStart(2, "0");
    const minutes = timeString.slice(-2).padStart(2, "0");
    return `${hours}:${minutes}`;
};

export const parseDateWithTimezone = (date: string) => {
    const parsedDate = parseDate(date, DATE_FORMAT);
    return new TZDate(parsedDate, TIMEZONE);
};

export const isSameDay = (date1: TZDate, date2: TZDate) => {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};

export const isBefore = (date1: TZDate, date2: TZDate) => {
    return date1.getTime() < date2.getTime();
};

export const isAfter = (date1: TZDate, date2: TZDate) => {
    return date1.getTime() > date2.getTime();
};

export const add = (date: TZDate, duration: { days?: number }) => {
    const newDate = new TZDate(date.getTime(), TIMEZONE);
    if (duration.days) {
        newDate.setDate(newDate.getDate() + duration.days);
    }
    return newDate;
};

export const isStoreClosedToday = (
    openSince: string,
    openUntil: string,
    currentDate: TZDate
) => {
    return (
        isBefore(currentDate, parseDateWithTimezone(openSince)) ||
        isAfter(currentDate, parseDateWithTimezone(openUntil))
    );
};
